// assets/copaic-cart-upsell.js
(() => {
  class CopaicUpsell {
    constructor() {
      this.cartDrawerSelector = '[data-mini-cart], .mini-cart, .cart-drawer';
      this.initAll();
      this.observeCartDrawer();
      this.hideAlreadyInCartCards();

      // If Zalify dispatches `cart:updated`, re-run logic on each update.
      document.addEventListener('cart:updated', () => {
        this.initAll();
        this.hideAlreadyInCartCards();
      });
    }

    initAll(root) {
      const scope = root || document;
      const cards = scope.querySelectorAll(
        '.copic-upsell-product:not([data-upsell-bound="true"])'
      );

      if (!cards.length) return;

      cards.forEach((card) => this.bindCard(card));
    }

    bindCard(card) {
      const select = card.querySelector('.copic-upsell-select');
      const button = card.querySelector('.copic-upsell-btn');
      const idInput = card.querySelector('input[name="id"]');

      if (!select || !button || !idInput) return;

      const onChange = () => {
        const variantId = select.value;

        if (variantId) {
          idInput.value = variantId;
          button.disabled = false;
          button.classList.add('is-enabled');
        } else {
          idInput.value = '';
          button.disabled = true;
          button.classList.remove('is-enabled');
        }
      };

      select.addEventListener('change', onChange);

      // Set initial state
      onChange();

      card.setAttribute('data-upsell-bound', 'true');
    }

    observeCartDrawer() {
      const drawer =
        document.querySelector(this.cartDrawerSelector);

      if (!drawer) return;
      if (window.__copaicUpsellObserverAttached) return;

      const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;

        for (const mutation of mutations) {
          if (mutation.addedNodes && mutation.addedNodes.length) {
            shouldReinit = true;
            break;
          }
        }

        if (shouldReinit) {
          this.initAll(drawer);
        }
      });

      observer.observe(drawer, {
        childList: true,
        subtree: true,
      });

      window.__copaicUpsellObserverAttached = true;
    }

    hideAlreadyInCartCards() {
      // Optional safety: do nothing if fetch is not available
      if (typeof fetch !== 'function') return;

      fetch('/cart.js', { cache: 'no-store' })
        .then((res) => res.json())
        .then((cart) => {
          if (!cart || !cart.items) return;

          const variantIdsInCart = new Set(
            cart.items.map((item) =>
              String(item.variant_id)
            )
          );

          document
            .querySelectorAll('.copic-upsell-product')
            .forEach((card) => {
              const mapping =
                card.dataset.fragranceVariantIds || '';

              if (!mapping) return;

              const variantIds = mapping
                .split(',')
                .map((v) => v.trim())
                .filter(Boolean);

              const intersects = variantIds.some((id) =>
                variantIdsInCart.has(id)
              );

              if (intersects) {
                card.remove();
              }
            });
        })
        .catch(() => {
          // Fail silently – upsell is non-critical
        });
    }
  }

  const init = () => {
    try {
      new CopaicUpsell();
    } catch (e) {
      console.error('CopaicUpsell error:', e);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
